module.exports = __webpack_public_path__ + "static/media/terminal.f32bcc71.svg";